module.exports = __webpack_public_path__ + "static/media/amazon-logo-transparent.748da9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/amazon-logo-transparent.png
// module id = 19
// module chunks = 0